import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { Avatar, Button, Card, CardActionArea, CardContent, Checkbox, Chip, FormControlLabel, FormGroup, IconButton, Tooltip, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { DEFAULT_FOOTER_HEIGHT_PX, DEFAULT_HEADER_HEIGHT_PX, DEFAULT_PAGE_SIZE, DEFAULT_TOOLBAR_HEIGHT_PX, handleValidateCodevalue, ROWS_PER_PAGE_OPTIONS } from '../Utility/constant';
import { useDispatch, useSelector } from 'react-redux';
import LeadDialog from './LeadDialog';
import { requestHideLoader, requestShowLoader } from '../Store/Global/action';
import { useIsMobile } from '../Utility/hooks/useIsMobile';
import { valueFormatter } from '../Utility/textHelper';
import StatusChip from './StatusChip';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { isPastDate } from '../Utility/calculations';
import LeadScoreBar from './LeadScoreBar';
import BiztantuSearchPageFooter from './BiztantuSearchPageFooter';
const DEFAULT_COLUMN_VISIBILITY = { invoicedqty: false, viewinvoice: false };

function CustomToolbar(props) {
  
  const {entityTextfieldsData,hasUnsavedChanges,handleEdit,handleDone,handleSave,handleCancel,isEditMode,isCustomization,isDashboard,
  handleMarkAsRead,showFilter, columnVisibilityModel1,setColumnVisibilityModel, columns,specificRolePermission, 
    internationalise , setIsOpenDialog ,isInvoiceScreen, isOrderScreen, quickFilterProps , isViewMode, handleDeleteProduct, clientId, 
    handleLaunchcampaign, isUserScreen, handleNotifyCustomer, isCustomerscreen,  orderstatus, handleNotifyUser, isOrderproduct, 
    selectionModel, isRequiredToolBar, handlegenerateinvoice, gridType, filename,isTaskScreen,handleOnClickTableAction,
    columnVisibilityModel } = props;
const dispatch = useDispatch()
const [checkedColumns, setCheckedColumns] = React.useState({});
  const [open , setOpen] = React.useState(false)

useEffect(() => {
  setColumnVisibilityModel(prevModel => {
    const hasPrev = prevModel && Object.keys(prevModel).length > 0;
    const nextModel = Object.fromEntries(
      columns.map(col => {
        const fieldConfig = entityTextfieldsData?.[col.field];

        if (fieldConfig && fieldConfig.visibility === false) {
          return [col.field, false];
        }

        if (hasPrev && prevModel[col.field] !== undefined) {
          return [col.field, prevModel[col.field]];
        }

        if (columnVisibilityModel && columnVisibilityModel[col.field] !== undefined) {
          return [col.field, columnVisibilityModel[col.field]];
        }

        return [col.field, true];
      })
    );

    // Bail out with the same reference if nothing changed.
    // This prevents an infinite re-render loop when columnVisibilityModel
    // is an inline default prop object (new reference on every render).
    if (hasPrev) {
      const keys = Object.keys(nextModel);
      const prevKeys = Object.keys(prevModel);
      if (
        keys.length === prevKeys.length &&
        keys.every(k => nextModel[k] === prevModel[k])
      ) {
        return prevModel;
      }
    }

    return nextModel;
  });
}, [columns, entityTextfieldsData, columnVisibilityModel, setColumnVisibilityModel]);

const allowedColumnsForCheckbox = React.useMemo(() => {
    return columns.filter((col) => {
      if (col.field === "actions" || col.field === "addfollowup") return false;

      const fieldConfig = entityTextfieldsData?.[col.field];

      if (fieldConfig && fieldConfig.visibility === false) {
        return false;
      }

      return true;
    });
  }, [columns, entityTextfieldsData]);

const handleCheckboxChange = (field) => {
  setCheckedColumns(prev => ({
    ...prev,
    [field]: !prev[field],
  }));
};

const handleSaveClick = () => {
  dispatch(requestShowLoader());

  setColumnVisibilityModel(prevModel => ({
    ...prevModel,
    ...checkedColumns,
  }));

  setOpen(false);
  dispatch(requestHideLoader());
};

const handleOpenFilter = () => {
  setOpen(true);

  const updated = {};
  allowedColumnsForCheckbox.forEach((col) => {
    updated[col.field] = columnVisibilityModel1?.[col.field] ?? true;
  });
  setCheckedColumns(updated);
};

  if(isRequiredToolBar) {
  return (
    <GridToolbarContainer style={{display: 'flex', justifyContent: 'space-between'}}>
     {showFilter &&
      <Box sx = {{width:"35%",display: 'flex', alignItems:"center"}}>
        <Box sx = {{width:"60%"}}>
   <Tooltip title={handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}>
  <Button sx = {{width:"100%"}} onClick={() => handleOpenFilter()}>
    {handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}
  </Button>
</Tooltip>
    </Box>
    </Box>
  }
      <LeadDialog
      open = {open}
      handleClose={()=>setOpen(false)}
      handleSave={handleSaveClick}
      title={handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}
      btnlabel = {handleValidateCodevalue(internationalise,"COMMON_SAVE")}
      >
      <FormGroup>
        <FormControlLabel sx = {{borderBottom : "2px solid #D9DDDC"}}
    control={
      <Checkbox
        checked={
          Object.keys(checkedColumns).length > 0 &&
          Object.values(checkedColumns).every(Boolean)
        }
        indeterminate={
          !Object.values(checkedColumns).every(Boolean) &&
          Object.values(checkedColumns).some(Boolean)
        }
        onChange={(e) => {
          const checked = e.target.checked;
          const updated = Object.fromEntries(
            allowedColumnsForCheckbox
              .map(col => [col.field, checked])
          );
          setCheckedColumns(updated);
        }}
      />
    }
    label={handleValidateCodevalue(internationalise, "COMMON_SELECT_ALL")}
  />
{allowedColumnsForCheckbox
    .map((item) => (
        <FormControlLabel
          key={item.field}
          control={
            <Checkbox
              checked={!!checkedColumns[item.field]}
              onChange={() => handleCheckboxChange(item.field)}
            />
          }
          label={item.headerName}
        />
      ))}
    </FormGroup>
    </LeadDialog>
    <Box sx = {{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
   {/* <GridToolbarExportContainer style={{margin: '0 10px'}}>
        <GridCsvExportMenuItem
          options={{
            fileName: `${filename}_${moment(new Date()).format()}`,
            delimiter: ';',
            utf8WithBom: true,
          }}
        />
      </GridToolbarExportContainer> */}
      <div>
      {isCustomization && (
        <>
          {isEditMode ? (
            <>
              <Button color="primary" onClick={handleCancel}>
                {handleValidateCodevalue(internationalise, "COMMON_CANCEL")}
              </Button>

              <Button color="primary" onClick={handleDone} style={{ margin: "0 10px" }}>
                {handleValidateCodevalue(internationalise, "COMMON_DONE")}
              </Button>
              |
              <Button color="primary" onClick={handleSave} style={{ margin: "0 0 0 10px" }}>
                {handleValidateCodevalue(internationalise, "COMMON_SAVE")}
              </Button>
            </>
          ) : hasUnsavedChanges ? (
            <Button color="primary" onClick={handleSave}>
              {handleValidateCodevalue(internationalise, "COMMON_SAVE")}
            </Button>
          ) : (
            <Button color="primary" onClick={handleEdit} >
              {handleValidateCodevalue(internationalise, "COMMON_EDIT")}
            </Button>
          )}
        </>
      )}
        {(isOrderproduct && !isViewMode) && <Button color="primary" onClick={handlegenerateinvoice} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
           {handleValidateCodevalue(internationalise,'TA_GEN_INV')}
        </Button>
        }
        {((isOrderScreen && (specificRolePermission?.isAllOrderManage || specificRolePermission?.isOrderTeamManage)) || (isInvoiceScreen && (specificRolePermission?.isAllInvoiceManage || specificRolePermission?.isInvoiceTeamManage))) && 
          <Button color="primary" onClick={()=>setIsOpenDialog(true)} disabled={!(selectionModel.length > 0)} style={{margin: '0 10px'}}>
            {isOrderScreen ? handleValidateCodevalue(internationalise,'TA_SO_RE_ASSIGN') : handleValidateCodevalue(internationalise,'TA_INV_RE_ASSIGN')}
          </Button>
        }
        { (isTaskScreen && (specificRolePermission?.isAllTaskManage || specificRolePermission?.isTaskTeamManage)) && 
          <Button color="primary" onClick={handleOnClickTableAction} disabled={!(selectionModel.length > 0)}>
            {handleValidateCodevalue(internationalise,'TA_TASK_RE_ASSIGN')}
          </Button>
        }

       {/* {(gridType == 'accountuser' && !isUserScreen) || gridType == 'task' && (
  <Button color="primary" onClick={handleNotifyUser} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
            {gridType=='task'?handleValidateCodevalue(internationalise,'TA_NOTI_SELECTED_CUST'):handleValidateCodevalue(internationalise,'TA_NOTI_SELECTED_USER')}
          </Button>
        )} */}
      
      {gridType == 'campaign' && (
          <Button color="primary" onClick={handleLaunchcampaign} disabled={!(selectionModel?.length == 1)} style={{margin: '0 10px'}}>
              {handleValidateCodevalue(internationalise,'TA_LAUNCH_PROD_CAMPAIGN')}
          </Button>
        )}
       {/* {gridType == "customer" && (
        <Button color="primary" onClick={handleNotifyCustomer} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
            {handleValidateCodevalue(internationalise,'TA_NOTI_SELECTED_CUST')}
        </Button>
       )} */}
       {isDashboard&& (
        <Button color="primary" onClick={handleMarkAsRead} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
            {handleValidateCodevalue(internationalise,'MARK_AS_READ')}
        </Button>
       )}
      </div>
      <GridToolbarQuickFilter {...quickFilterProps} />
      </Box>
    </GridToolbarContainer>
  );
      } else {
        return null;
      }
}


export default function DataGridTable({rowsToView,entityTextfieldsData,hasUnsavedChanges,handleEdit,handleDone, handleSave,handleCancel,showMobileFooter =false,getRowHeight,
  isEditMode,isCustomization,isCellEditable,isLead,isSearchScreen=false,showOwner="ownerId",titleField="id", showId = true,showName="", rowHeight=45,
  renderValuesOnCard,handleOnClickCard,isDashboard = false,handleMarkAsRead, getRowClassName,showFilter=true,onCellClick,hideFooter=false,
  handleProcessRowUpdate,setIsOpenDialog , marginTop= "20px", isInvoiceScreen, isOrderScreen , isLoading = false, isViewMode, clientId,
  height = "calc(100vh - 221px)", isUserScreen = true, handleNotifyCustomer, isCustomerscreen = true, handleNotifyUser, handleLaunchcampaign, 
  isRowSelectable = true, isInvoiceproduct = false,  orderstatus, handlegenerateinvoice, isOrderproduct = false,filename="", 
  columnVisibilityModel = DEFAULT_COLUMN_VISIBILITY, selectionModel, gridType="", setSelectionModel, isCheckboxReq = true, 
  isRequiredToolBar = true , dataGridData = [], columns, rowModesModel, handleUpdateProduct, handleDeleteProduct,isTaskScreen,handleOnClickTableAction,
  pagedData, paginationState, onPageChange, onPageSizeChange}) {
  const [columnVisibilityModel1,setColumnVisibilityModel] = React.useState(columnVisibilityModel || {})
  const [rows, setRows] = React.useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  const ownerlist = useSelector(state => state?.owner?.ownerlist);
  useEffect(() => {
    setRows(dataGridData || [])
  },[dataGridData])

  const displayRows = pagedData?.content ?? rows;

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };
  const isMobile =  useIsMobile();
  const processRowUpdate = async(newRow, oldRow) => {
    if(JSON.stringify(oldRow) === JSON.stringify(newRow)){
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"),{variant:"info"})
      return oldRow;
    }
    if(isInvoiceproduct) {
      if(parseInt(newRow?.invoiceqty) > parseInt(oldRow?.remainingQty)) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,`COMMON_INV_QTY_REM_QTY_WARNING`), {variant: 'error'});
        setRows(rows.map((row) => (row.id === newRow.id ? row : row)));
        handleUpdateProduct(oldRow);
        return oldRow;
      } else {
        handleUpdateProduct(newRow); 
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      }

    } else {
      // if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
      //   enqueueSnackbar(`No data changed.`, {variant: 'info'});
      // } else {
        await handleUpdateProduct(newRow); 
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      // }
      
    }
    
  }; 

  const handleProcessRowUpdateError = React.useCallback(() => {
    
  },[]) 

  const handleEditCellChange = (newValue, rowIndex, columnId) => {
  }

  const leftItems = renderValuesOnCard?.filter(item => item?.left) || [];
  const rightItems = renderValuesOnCard?.filter(item => item?.right) || [];
  const fullWidthItems = renderValuesOnCard?.filter(
    item => !item?.left && !item?.right
  ) || [];
  const lookupData = useSelector(state => state?.lookup?.lookupData)
const userMap = React.useMemo(() => {
  const map = {};
  ownerlist?.forEach((user) => {
    map[user.id] = user;
  });
  return map;
}, [ownerlist]);

const getInitials = (id) => {
  const user = userMap[id];
  if (!user) return "";

  return `${user?.firstName?.[0] || ""} ${
    user?.lastName?.[0] || ""
  }`;
};

const lookupMap = React.useMemo(() => {
  const map = {};

  lookupData?.forEach((item) => {
    item.codes?.forEach((codeItem) => {
      map[String(codeItem.name)] = codeItem?.systemLookupCode?.name;

    });
  });

  return map;
}, [lookupData]);

const getClientLookupCode = React.useCallback((systemLookupCode) => {
  return lookupMap[String(systemLookupCode)] || "";
}, [lookupMap]);

const renderItem = (card, item, fullValue, displayValue, align = "left") => {
  // NEXT FIELD
  if (item?.field === "nextFollowupDate") {
    return (
      <Tooltip key={item.field} title={fullValue || ""}>
        <Chip
          variant="outlined"
          className={
            isPastDate(card.nextFollowupDate) && card?.read === false
              ? "secondary-bg-color"
              : ""
          }
          label={card?.nextFollowupDate}
        />
      </Tooltip>
    );
  }

  // AVATAR
  if (item?.useAvatar) {
    return (
      <Tooltip key={item.field} title={fullValue || ""}>
        <Box
          display="flex"
          justifyContent={align === "right" ? "flex-end" : "flex-start"}
        >
          <IconButton sx={{ p: 0.5 }}>
            <Avatar
              sx={{
                bgcolor: "var(--secondary-color)",
                fontSize: "15px",
                color: "black",
                fontWeight: "bold",
              }}
            >
              {getInitials(displayValue)}
            </Avatar>
          </IconButton>
        </Box>
      </Tooltip>
    );
  }

  if(item?.useBar){
    return(
      <LeadScoreBar score = {displayValue}/>
    )  
  }
  //  CHIP
  if (item?.useChip) {
    return (
      <Tooltip key={item.field} title={fullValue || ""}>
        <StatusChip
          isLead={isLead}
          chipType={item.chipType}
          systemLookup={
            card?.systemLookUpCodeStatus ??
            getClientLookupCode(card[item.field])
          }
          status={card[item.field]}
          internationalise={internationalise}
        />
      </Tooltip>
    );
  }
  //  DEFAULT (TEXT)
  return (
    <Tooltip key={item.field} title={fullValue || ""}>
      <Typography
        sx={{
          paddingTop : "10px",
          fontWeight: 600,
          width: "100%",
          textAlign: align === "right" ? "right" : "left",
        }}
      >
        {displayValue}
      </Typography>
    </Tooltip>
  );
};
const computedHeight = rowsToView
    ? DEFAULT_HEADER_HEIGHT_PX
      + rowHeight * rowsToView
      + (hideFooter ? 0 : DEFAULT_FOOTER_HEIGHT_PX)
      + (isRequiredToolBar ? DEFAULT_TOOLBAR_HEIGHT_PX : 0)
    : height;
  return (
    <Box
    className = {isMobile ? 'hide-scrollbar' : ''}
      sx={{
        backgroundColor :"#FFFFFF",
        height: computedHeight,
        overflow: 'auto',
        // marginTop: {marginTop},
        width: '100%',
        '& .actions': {
          color: 'text.secondary',
        },
        '& .textPrimary': {
          color: 'text.primary',
        },
      }}
    >
    {isMobile ?
    
    <Box
  sx={{
    display: "flex",
    justifyContent:"space-between",
    flexDirection: "column",
    minHeight: "calc(100vh - 218px)",
  }}
>
  <Box
    className ={isSearchScreen ? 'pl-10 pr-10 pt-10' : ''}
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
      },
      gap: 1
    }}
  >
    {
    displayRows?.length === 0 
    ?
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      gridColumn="1 / -1"
      height="200px"
    >
    <Typography variant="body1">
      {handleValidateCodevalue(internationalise,"COMMON_NO_DATA_FOUND")}
    </Typography>
    </Box>
    :
  displayRows.map((card) => {
  const finalTitleField = titleField || "id";
  const isRead = !!card?.read;
  return (
    <Card
      key={card.id}
      sx={{
        border : "1px solid #CECECE",
        margin : "2px"
      }}
    >
      <CardActionArea
        onClick={() => handleOnClickCard?.(card)}
        sx={{ cursor: 'pointer' }}
      >
        <CardContent>
        <Box display="flex" justifyContent="space-between" width="100%" gap = {"8px"}>
          <Box display="flex" justifyContent="flex-start" alignItems={"center"} gap= "12px"width="48%" >
          {card?.read !== undefined && (
        <Tooltip
          title={handleValidateCodevalue(
            internationalise,
            isRead ? "DB_MARK_AS_UNREAD" : "DB_MARK_AS_READ"
          )}
        >
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleMarkAsRead(card);
            }}
          >
            {isRead ? (
              <TaskAltIcon fontSize="small" className="secondary-color" />
            ) : (
              <RadioButtonUncheckedIcon fontSize="small" className="secondary-color"/>
            )}
          </IconButton>
        </Tooltip>
      )}
          {showId && (
            <Typography 
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "18px",
                  md: "20px",
                  lg: "22px"
                },
                fontWeight: 600
              }}
            >
              {card?.[finalTitleField]}
            </Typography>
          )}
          {showName && 
          (
            <Typography 
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "18px",
                  md: "20px",
                  lg: "22px"
                },
                fontWeight: 600
              }}
            >
              {card?.[showName]}
            </Typography>
          )}
          {card?.leadScore !== undefined && card?.leadScore !== null && (
            <LeadScoreBar score={card.leadScore} />
          )}
          </Box>
          {card?.[showOwner] &&
          <Box display="flex" justifyContent="flex-end">
                <IconButton
                  sx={{ p: 0.5 }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "var(--secondary-color)",
                      fontSize: "15px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {getInitials(card?.[showOwner])}
                  </Avatar>
                </IconButton>
          </Box>
          }
        </Box>
          <Box display="flex" justifyContent="space-between" alignItems={"center"} width="100%" gap = {"8px"}>
  
  {/* LEFT */}
  <Box display="flex" flexDirection="column" width="48%">
    {leftItems?.map((item) => {
    const { displayValue, fullValue } = valueFormatter(card, item, internationalise)|| {};
    return renderItem(card, item, fullValue, displayValue, "left");  
    })}
  </Box>

  {/* RIGHT */}
  <Box display="flex" flexDirection="column"width="48%" alignItems="flex-end">
    {rightItems?.map((item) => {
      const { displayValue, fullValue } = valueFormatter(card, item, internationalise)|| {};
      return renderItem(card, item, fullValue, displayValue, "right");
    })}
  </Box>
</Box>

{/*  Full Width Rows */}
{fullWidthItems?.map((item) => {
  const { displayValue, fullValue } = valueFormatter(card,item,internationalise)|| {};

  return (
    
    <Box display="flex"paddingTop = {"10px"} justifyContent={"space-between"} width="100%" gap = {"8px"}>
      {item?.useLabel && (
           <Typography
                  sx={{
                    flex: 1,
                    fontSize: { xs: 12, sm: 13, md: 14 },
                  }}
                >
                  {handleValidateCodevalue(internationalise, item?.useLabel)}:
          </Typography>
      )}
      {item?.useChip ? (
          <StatusChip
                    isLead = {isLead}
                    systemLookup = {card?.systemLookUpCodeStatus ?? getClientLookupCode(card[item.field])}
                    status={card[item.field]}
                    internationalise={internationalise}
                  />
          )
          :
        (
          <Typography
                  sx={{
                    flex: 1,
                    fontSize: { xs: 12, sm: 13, md: 14 },
                    fontWeight: "600",
                    textAlign : item?.useLabel ? "right" : "left"
                  }}
                >
                  {displayValue}
          </Typography>
        )}
    </Box>
  );
})}
        </CardContent>
      </CardActionArea>
    </Card>
  );
})}
  </Box>
  {showMobileFooter &&
      <BiztantuSearchPageFooter
        paginationState={paginationState}
        pagedData={pagedData}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
  />
  }
  </Box>
  :
      <DataGrid
       rowHeight={rowHeight}
      getRowHeight={getRowHeight}
       disableColumnMenu
      sx={{
      border: 1,                      // overall grid border
      borderColor: 'divider',

      '& .MuiDataGrid-columnHeader': {
      borderRight: '1px solid #CECECE',
      borderLeft: 'none',
    },
      '& .MuiDataGrid-columnHeaders': {
        border: '1px solid #CECECE',
      },
        // Cells styling
        '& .MuiDataGrid-cell:first-child': {
        borderLeft: '1px solid #CECECE',
        borderRight: '1px solid #CECECE', // same for first column cells
        },
        '& .MuiDataGrid-cell:last-child': {
        borderRight: '1px solid #CECECE', // same for last column cells
        },
        '& .MuiDataGrid-cell:not(:first-child):not(:last-child)': {
        borderRight: '1px solid #CECECE',
        },
    }}
    {...(isCellEditable && { isCellEditable })}
      getRowClassName={getRowClassName}
        onCellClick={onCellClick}
        hideFooter = {hideFooter}
        isViewMode = {false}
        rows={displayRows}
      {...(pagedData && {
          paginationMode: "server",
          pagination: true,
          rowCount: pagedData.totalElements ?? 0,
          page: paginationState?.page ?? 0,
          pageSize: paginationState?.size ?? DEFAULT_PAGE_SIZE,
          onPageChange,
          onPageSizeChange,
          rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
      })}
        className='biztantu-datagrid'
        columnVisibilityModel = {columnVisibilityModel1}
        columns={columns}
        editMode="row"
        checkboxSelection = {isCheckboxReq}
        rowModesModel={rowModesModel}
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        {...(setSelectionModel && {
          selectionModel: selectionModel,
          onSelectionModelChange: (newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }
        })}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableSelectionOnClick
        // isRowSelectable={isRowSelectable}
        isRowSelectable={(params) => {
     if (params?.row?.hasOwnProperty('remainingQty')) {
      return (params.row.remainingQty > 0 && !isViewMode );
    }
    if (typeof isRowSelectable === 'function') {
      return isRowSelectable(params);
    }

    // Case 3: If it's a boolean
    return !!isRowSelectable;
        }}
        componentsProps={{
          toolbar: {
            showQuickFilter: rows?.length > 0 ? true: false,
            quickFilterProps: { debounceMs: 500, placeholder: handleValidateCodevalue(internationalise,'TA_SEARCH_IN_TABLE') },
            isViewMode,
            isRequiredToolBar, gridType, selectionModel,filename,
            handleDeleteProduct,isOrderproduct, handlegenerateinvoice,
            orderstatus, handleNotifyUser, handleLaunchcampaign,isCustomerscreen,
            handleNotifyCustomer, isUserScreen,clientId,
            isOrderScreen , setIsOpenDialog,internationalise,specificRolePermission,isInvoiceScreen,
            columns,columnVisibilityModel1,setColumnVisibilityModel,showFilter,isDashboard,handleMarkAsRead,
            isTaskScreen,handleOnClickTableAction,isCustomization,isEditMode,handleEdit,handleSave,handleCancel,
            handleDone,hasUnsavedChanges,entityTextfieldsData,columnVisibilityModel
          },
        }}
        components={{
          Toolbar: CustomToolbar,
        }}
        loading={isLoading}
        processRowUpdate={handleProcessRowUpdate ?? processRowUpdate}
        onEditRowsModelChange={handleEditCellChange}
        experimentalFeatures={{ newEditingApi: true }}
        onProcessRowUpdateError={handleProcessRowUpdateError}
      />
      }
    </Box>
  );
}
